const getters = {
  passoAtual: (state) => state.passoAtual,
  listaUnidades: (state) => state.listaUnidades,
  listaDocumentos: (state) => state.listaDocumentos,
  unidadeSelecionada: (state) => state.unidadeSelecionada,
  documentoSelecionado: (state) => state.documentoSelecionado,
  numeroDocumento: (state) => state.numeroDocumento
}

export default getters
